/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createbusinesserror2Inputs */

const en_createbusinesserror2 = /** @type {(inputs: Createbusinesserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create business. Please try again.`)
};

const de_createbusinesserror2 = /** @type {(inputs: Createbusinesserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen konnte nicht erstellt werden. Versuch's nochmal.`)
};

/**
* | output |
* | --- |
* | "Failed to create business. Please try again." |
*
* @param {Createbusinesserror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createbusinesserror2 = /** @type {((inputs?: Createbusinesserror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createbusinesserror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createbusinesserror2(inputs)
	return de_createbusinesserror2(inputs)
});
export { createbusinesserror2 as "createBusinessError" }